<template>
  <div>
    <v-navigation-drawer
      v-model="rightDrawer"
      right
      temporary
      fixed
      width="1400"
    >
      <v-toolbar
        dense
        flat
        dark
        class="primary"
      >
        <v-btn
          icon
          @click.stop="rightDrawer = false"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span>
          {{ $t('Rules') }}
        </span>
        <v-spacer />
        <v-btn icon>
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>arrow_forward</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container
        grid-list-xl
        fluid
      >
        <v-layout
          v-if="selected"
          row
          wrap
        >
          <v-flex xs12>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                md3
                class="pl-5"
              >
                <h3 class="title font-weight-regular pt-3">
                  {{ $t('Details') }}
                </h3>
                <span
                  class="caption"
                  v-html="$t('Write a descriptive name and select a primary action for this <br> filter to execute when the rules below are met')"
                />
                <v-switch
                  v-model="selected.active"
                  :label="selected.active ? $t('Enabled') : $t('Disabled')"
                  class="mt-2"
                  color="primary"
                />
              </v-flex>
              <v-flex
                xs12
                md8
              >
                <v-card
                  flat
                  class="pa-3"
                >
                  <v-text-field
                    v-model="selected.name"
                    outline
                    label="Name"
                  />
                  <v-radio-group>
                    <template v-slot:label>
                      <div><strong>{{ $t('Action') }}</strong></div>
                    </template>
                    <v-radio
                      color="red"
                      value="cancel_order"
                    >
                      <template v-slot:label>
                        <div>
                          <strong class="red--text mr-1">{{ $t('Cancel Order') }} </strong>
                          {{ $t('(immediately cancel order that meets the rules below)') }}
                        </div>
                      </template>
                    </v-radio>
                    <v-radio
                      color="primary"
                      value="warn"
                    >
                      <template v-slot:label>
                        <div>
                          <strong class="primary--text mr-1">{{ $t('Warning') }} </strong>
                          {{ $t('(warn me on admin email)') }}
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
              </v-flex>
            </v-layout>
            <v-divider />
          </v-flex>
          <v-flex xs12>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                md3
                class="pl-5"
              >
                <h3 class="title font-weight-regular pt-3">
                  {{ $t('Conditions') }}
                </h3>
                <span
                  class="caption"
                  v-html="$t('Select appropriate rule(s) to filter the fraudulent activity <br> you are seeing. You can edit these rules at any time.')"
                />
                <div v-if="!advancedFilter">
                  <span
                    class="caption"
                  >{{ $t('The filter will act on order only if') }}
                  </span>
                  <v-btn-toggle
                    class="transparent mx-2"
                    mandatory
                  >
                    <v-btn
                      :value="$t('any')"
                      small
                      flat
                    >
                      {{ $t('any') }}
                    </v-btn>

                    <v-btn
                      :value="$t('all')"
                      small
                      flat
                    >
                      {{ $t('all') }}
                    </v-btn>
                  </v-btn-toggle>
                  <span class="caption">{{ $t('of these conditions are match') }}</span>
                </div>

                <v-switch
                  v-model="advancedFilter"
                  :label="$t('Advanced filters')"
                  color="primary"
                  class="mt-3"
                />
              </v-flex>
              <v-flex
                xs12
                md8
              >
                <v-card
                  v-if="!advancedFilter"
                  flat
                  class="pa-3"
                >
                  <simple-query-builder
                    :types="types"
                    :operators="operators"
                    :operands="operands"
                    :max-depth="1"
                    :_query="selected.filter"
                    @add-group="handleArguments"
                    @add-rule="handleArguments"
                    @remove-group="handleArguments"
                    @remove-rule="handleArguments"
                    @change-operand="_handleSelectOperand"
                    @change-operator="handleArguments"
                    @change-value="handleArguments"
                    @search="_handleSearch"
                  />
                </v-card>
                <v-card
                  v-if="advancedFilter"
                  flat
                  class="pa-3"
                >
                  <query-builder
                    :types="types"
                    :operators="operators"
                    :operands="operands"
                    :max-depth="2"
                    :_query="selected.filter"
                    @add-group="handleArguments"
                    @add-rule="handleArguments"
                    @remove-group="handleArguments"
                    @remove-rule="handleArguments"
                    @change-operand="_handleSelectOperand"
                    @change-operator="handleArguments"
                    @change-value="handleArguments"
                    @search="_handleSearch"
                  />
                </v-card>
              </v-flex>
            </v-layout>
            <v-divider />
          </v-flex>
          <v-flex xs12>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                md3
                class="pl-5"
              >
                <h3 class="title font-weight-regular pt-3">
                  {{ $t('Options') }}
                </h3>
                <span
                  class="caption"
                >{{ $t('Pick up a few options for this filter') }}</span>
              </v-flex>
              <v-flex
                xs12
                md8
              >
                <v-card
                  flat
                  class="pa-3"
                >
                  <v-checkbox
                    :label="$t('Re-stock product inventory?')"
                    color="primary"
                  />
                  <v-checkbox
                    :label="$t('Send cancelation email?')"
                    color="primary"
                  />
                  <v-checkbox
                    :label="$t('Refund transaction amount (if available)?')"
                    color="primary"
                  />
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            class="text-xs-right"
          >
            <v-divider />
            <v-btn
              class="primary mt-2"
              large
            >
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <LoadingState
      v-if="loading"
      :loading="loading"
    />
    <v-layout
      row
      wrap
      color="transparent"
    >
      <!-- Title -->
      <v-flex xs12>
        <v-toolbar
          flat
          color="transparent"
          class="my-3"
        >
          <v-toolbar-title>
            {{ $t('Fraud Rules') }}
          </v-toolbar-title>
          <v-spacer />
          <v-spacer />
        </v-toolbar>
      </v-flex>
      <v-flex
        xs12
        md8
        class="mb-3"
      >
        <h3 class="title font-weight-regular ml-3">
          {{ $t('Checkout validation') }}
        </h3>
        <RulesList
          :loading="false"
          :items="cRules"
          @selected="setRightDrawer"
        />
      </v-flex>
      <v-flex
        xs12
        md8
        class="mt-5"
      >
        <h3 class="title font-weight-regular ml-3">
          {{ $t('Order processing validation') }}
        </h3>
        <RulesList
          :loading="false"
          :items="oRules"
          @selected="setRightDrawer"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import QueryBuilder from '../components/QueryBuilder'
import SimpleQueryBuilder from '../components/SimpleFilter/SimpleQueryBuilder'
import RulesList from '../components/RulesDataTable'

const types = [{ text: this.$t('ALL'), value: 'ALL' }, { text: this.$t('ANY'), value: 'ANY' }]
const operators = [
  { text: this.$t('equals'), value: '$eq' },
  { text: this.$t('not equals'), value: '$ne' },
  { text: this.$t('greater than'), value: '$gt' },
  { text: this.$t('lower than'), value: '$lt' },
  { text: this.$t('like'), value: '$like' }
]
const operands = [
  { text: this.$t('ID'), value: 'id', type: 'number', disabled: true },
  { text: this.$t('Admin ID'), value: 'admin_id', type: 'number' },
  { text: this.$t('Admin name'), value: 'admin_name', type: 'string' },
  {
    text: this.$t('Resource'),
    value: 'resource',
    type: 'string',
    values: [
      { text: this.$t('Contents'), value: 'contents' },
      { text: this.$t('Contents options'), value: 'contents_options', disabled: true },
      { text: this.$t('content option items'), value: 'contents_options_items' },
      { text: this.$t('order'), value: 'order' }
    ]
  },
  {
    text: this.$t('Action'),
    value: 'action',
    type: 'string',
    values: [
      { text: 'start_sync_list_item', value: 'start_sync_list_item' },
      { text: 'end_sync_list_item', value: 'end_sync_list_item' },
      { text: 'end_sync_list_item', value: 'sync_list_item' },
      { text: 'delete_non_exist_items', value: 'delete_non_exist_items' },
      { text: 'different_item', value: 'different_item' },
      { text: 'sync_entire_item', value: 'sync_entire_item' },
      { text: 'sync_single_item', value: 'sync_single_item' },
      { text: 'sync_incremental_item', value: 'sync_incremental_item' },
      { text: 'resend_code', value: 'resend_code' },
      { text: 'resend_notice', value: 'resend_notice' }
    ]
  },
  {
    text: this.$t('BOOL'),
    value: 'bool_test',
    type: 'boolean',
    values: [
      { text: 'True', value: true },
      { text: 'False', value: false },
      { text: 'Must fail', value: 'true1' }
    ]
  },
  { text: this.$t('DATE'), value: 'date_test', type: 'date' },
  { text: this.$t('DATETIME'), value: 'datetime_test', type: 'datetime' }
]

const cRules = [
  {
    id: 'jklsdfj98sdf',
    name: 'Block Israel from shipping',
    trigger: 'Customer created',
    action: 'Send slack message',
    active: true,
    filter: {
      operator: 'ALL',
      children: [
        {
          type: 'rule',
          query: {
            operator: '$eq',
            operand: 'resource',
            value: 'contents'
          }
        }
      ]
    }
  }
]

const oRules = [
  {
    id: 'jklsdfj9855sdf',
    name: 'Hide products',
    trigger: 'Customer created',
    action: 'Hide product,Send slack message',
    active: true,
    filter: {
      operator: 'ALL',
      children: [
        {
          type: 'rule',
          query: {
            operator: '$ne',
            operand: 'resource',
            value: 'contents'
          }
        }
      ]
    }
  }
]

export default {
  name: 'Rules',

  components: {
    LoadingState,
    QueryBuilder,
    SimpleQueryBuilder,
    RulesList
  },

  data () {
    return {
      rightDrawer: false,
      advancedFilter: false,
      types,
      operators,
      operands,
      cRules,
      oRules,
      loading: false,
      selected: null
    }
  },

  methods: {
    _handleSearch (query, validator) {
    },

    handleArguments (a, b, c, d, e) {
    },

    _handleSelectOperand (value, query, positions, a) {
    },

    setRightDrawer (id) {
      this.selected =
          this.cRules.find(r => r.id === id) ||
          this.oRules.find(r => r.id === id)
      this.rightDrawer = true
    }
  }
}
</script>
